module.exports = __webpack_public_path__ + "img/UTEAST-1.876974da.jpg";